import { config } from "./config";
// @ts-ignore
import useApi from "./ServiceClient.tsx";
import { useEffect, useState } from "react";

// 🔴 Module-level cache (persists across re-renders but resets on full reload)
let cachedDropdownData: any = null;

export const useDropdownData = () => {
  const { GET } = useApi(); // Call `useApi` inside a React hook
  const [data, setData] = useState({
    companyTypes: cachedDropdownData?.companyTypes || [],
    industries: cachedDropdownData?.industries || [],
    tenantUserType: cachedDropdownData?.tenantUserType || [],
    userManagemnetUserType: cachedDropdownData?.userManagemnetUserType || [],
    countries: cachedDropdownData?.countries || [],
    fields : cachedDropdownData?.fields || [],
    loading: !cachedDropdownData,
    error: null,
  });

  useEffect(() => {
    if (cachedDropdownData) return; // ✅ Skip API call if data is cached
    const fetchData = async () => {
      try {
        const [
          companies,
          industriesData,
          tenantUserType,
          userManagemnetUserType,
          countries,
          fields
        ] = await Promise.all([
          getCompanyTypes(),
          getIndustries(),
          getUserTypes("isTenantManagement"),
          getUserTypes("isUserManagement"),
          getCountries(),
          getFields(),
        ]);

        const newData = {
          companyTypes: companies,
          industries: industriesData,
          tenantUserType,
          userManagemnetUserType,
          countries,
          fields : fields?.map((field) => ({
            ...field,
            name: field?.displayName, 
            id: field?.id
          })),
          loading: false,
          error: null,
        };

        cachedDropdownData = newData; // ✅ Store in module-level variable
        setData(newData);
      } catch (error) {
        setData((prev) => ({
          ...prev,
          loading: false,
          error: error.message || "Failed to fetch dropdown data",
        }));
      }
    };

    fetchData();
  }, []);

  const getCompanyTypes = () => {
    const response = GET(config?.common?.END_POINTS?.GET_COMPANY_TYPES);
    return response;
  };

  const getIndustries = () => {
    const response = GET(config?.common?.END_POINTS?.GET_INDUSTRIES);
    return response;
  };

  const getUserTypes = (params) => {
    const response = GET(
      `${config?.common?.END_POINTS?.GET_USER_TYPE}?${params}=true`
    );
    return response;
  };

  const getCountries = () => {
    const response = GET(`${config?.common?.END_POINTS?.GET_COUNTRIES}`);
    return response;
  };

  const getFields = () => {
    const response = GET(`${config?.common?.END_POINTS?.GET_FIELDS}`);
    return response;
  };

  return data;
};
